<div class="flex flex-col flex-auto w-full p-4 xs:p-2">
  <div class="flex flex-wrap w-full">
    <div class="flex items-center justify-between w-full mb-4 px-4 xs:pr-0">
      <div class="mr-6">
        <h2 class="m-0">{{ property?.name || property.address?.address_string }}</h2>
        <div class="text-secondary tracking-tight">Explore demographic drivers in the market.</div>
      </div>
    </div>
    <div class="flex flex-wrap w-full lt-xl:w-full flex-col">
      <div class="flex flex-col bg-card shadow-md rounded overflow-hidden" *ngIf="aggregateMarketDemographics">
        <div class="flex flex-col p-4 pl-6">
          <div class="flex items-center justify-between">
            <div class="font-bold text-md text-secondary uppercase tracking-wider">Demographics</div>
          </div>
        </div>
        <div class="flex flex-col flex-auto justify-start text-md px-6 pb-3">
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full"></div>
            </div>
            <div class="w-1/4 font-medium text-secondary">1 Mile</div>
            <div class="w-1/4 font-medium text-secondary">3 Mile</div>
            <div class="w-1/4 font-medium text-secondary">5 Mile</div>
            <ng-container *ngIf="aggregateMarketDemographics">
              <div class="w-1/4 font-medium text-secondary">Postal Code</div>
              <div class="w-1/4 font-medium text-secondary">County</div>
              <div class="w-1/4 font-medium text-secondary">CBSA</div>
            </ng-container>
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Total Population</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][0]['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['distances'][0]['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['distances'][0]['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['distances'][0]['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][1]['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['distances'][1]['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['distances'][1]['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['distances'][1]['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][2]['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['distances'][2]['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['distances'][2]['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['distances'][2]['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['zip_code']['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['zip_code']['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['zip_code']['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['zip_code']['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['county']['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['county']['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['county']['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['county']['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['cbsa']['population'] | number: '1.0-0' }}
                <span class="priority text-sm">
                  (<span *ngIf="aggregateMarketDemographics['cbsa']['populationCngPct2020'] < 0">-</span>

                  <!-- High -->
                  <span *ngIf="aggregateMarketDemographics['cbsa']['populationCngPct2020'] > 0">+</span>
                  {{ aggregateMarketDemographics['cbsa']['populationChgPct_2020'] | percent: '1.0' }})
                </span>
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Total Households</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][0]['households'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][1]['households'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][2]['households'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['zip_code']['households'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['county']['households'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['cbsa']['households'] | number: '1.0-0' }}
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Med. Household Income</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][0]['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][1]['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][2]['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['zip_code']['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['county']['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['cbsa']['medianHouseholdIncome'] | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Med. Housing Value</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][0]['medianHouseholdValue']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][1]['medianHouseholdValue']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['distances'][2]['medianHouseholdValue']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['zip_code']['medianHouseholdValue']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['county']['medianHouseholdValue'] | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
              <div class="w-1/4 font-medium">
                {{
                  aggregateMarketDemographics['cbsa']['medianHouseholdValue'] | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Total Housing Units</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][0]['housingUnits'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][1]['housingUnits'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][2]['housingUnits'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['zip_code']['housingUnits'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['county']['housingUnits'] | number: '1.0-0' }}
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['cbsa']['housingUnits'] | number: '1.0-0' }}
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Renter Occupied Housing Units</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][0]['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{
                    aggregateMarketDemographics['distances'][0]['housingUnitsRenterOccupiedPct'] | percent: '1.0'
                  }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][1]['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{
                    aggregateMarketDemographics['distances'][1]['housingUnitsRenterOccupiedPct'] | percent: '1.0'
                  }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][2]['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{
                    aggregateMarketDemographics['distances'][2]['housingUnitsRenterOccupiedPct'] | percent: '1.0'
                  }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['zip_code']['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{
                    aggregateMarketDemographics['zip_code']['housingUnitsRenterOccupiedPct'] | percent: '1.0'
                  }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['county']['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['county']['housingUnitsRenterOccupiedPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['cbsa']['housingUnitsRenterOccupied'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['cbsa']['housingUnitsRenterOccupiedPct'] | percent: '1.0' }})</span
                >
              </div>
            }
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Vacant Housing Units</div>
            </div>
            @if (aggregateMarketDemographics) {
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][0]['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['distances'][0]['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][1]['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['distances'][1]['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['distances'][2]['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['distances'][2]['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['zip_code']['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['zip_code']['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['county']['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['county']['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
              <div class="w-1/4 font-medium">
                {{ aggregateMarketDemographics['cbsa']['housingUnitsVacant'] | number: '1.0-0' }}
                <span class="text-sm"
                  >({{ aggregateMarketDemographics['cbsa']['housingUnitsVacantPct'] | percent: '1.0' }})</span
                >
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap w-1/2 lt-xl:w-full flex-col">
      <div class="flex flex-col bg-card shadow-md rounded overflow-hidden mt-4" *ngIf="demographics">
        <div class="flex flex-col p-4 pl-6">
          <div class="flex items-center justify-between">
            <div class="font-bold text-md text-secondary uppercase tracking-wider">
              Postal Code Demographic Forecasts ({{ postalCode }})
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-auto justify-start text-md px-6 pb-3">
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full"></div>
            </div>
            <div class="w-1/5 font-medium text-secondary">2000</div>
            <div class="w-1/5 font-medium text-secondary">2010</div>
            <div class="w-1/5 font-medium text-secondary">2020</div>
            <div class="w-1/5 font-medium text-secondary">Current</div>
          </div>
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Population</div>
            </div>
            <div class="w-1/5 font-medium">{{ demographics.population_2000 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">{{ demographics.population_2010 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">{{ demographics.population_2020 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">
              @if (aggregateMarketDemographics) {
                {{ aggregateMarketDemographics['zip_code']['population'] | number: '1.0-0' }}
              }
            </div>
          </div>

          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(213, 63, 140)"></div>
              <div class="truncate">Households</div>
            </div>
            <div class="w-1/5 font-medium">{{ demographics.households_2000 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">{{ demographics.households_2010 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">{{ demographics.households_2020 | number: '1.0-0' }}</div>
            <div class="w-1/5 font-medium">
              @if (aggregateMarketDemographics) {
                {{ aggregateMarketDemographics['zip_code']['housingUnits'] | number: '1.0-0' }}
              }
            </div>
          </div>

          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(184, 50, 128)"></div>
              <div class="truncate">Median Household Income</div>
            </div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">
              @if (aggregateMarketDemographics) {
                {{
                  aggregateMarketDemographics['zip_code']['medianHouseholdIncome']
                    | tsCurrency: 'USD' : 'symbol' : '1.2-2'
                }}
              }
            </div>
          </div>
          <!---->
          <div class="flex items-center justify-between py-3 border-b last:border-b-0 ng-star-inserted">
            <div class="flex items-center w-1/4">
              <div class="flex-shrink-0 w-2 h-2 mr-3 rounded-full" style="background-color: rgb(246, 135, 179)"></div>
              <div class="truncate">Total Crime Risk</div>
            </div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">-</div>
            <div class="w-1/5 font-medium">
              @if (aggregateMarketDemographics) {
                {{ aggregateMarketDemographics['zip_code']['CRMCYTOTC'] / 100 | number: '1.2-2' }}
              }
              x
            </div>
          </div>
          <!---->
        </div>
      </div>
    </div>
    <!--
    <div class="flex flex-auto w-1/2 min-w-80 pl-4 flex-col mt-4">
      <div class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden">
        <div class="flex flex-col p-6 pr-4 pb-4">
          <div class="flex items-center justify-between">
            <div class="flex flex-col">
              <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">Unemployment</div>
              <div class="text-sm text-hint font-medium">Monthly Unemployment data from BLS</div>
            </div>
          </div>
          <div class="flex flex-col flex-auto">
            <ng-container *ngIf="blsUnemploymentOptions">
              <apx-chart
                *ngIf="(blsUnemploymentData | json) != '[]'; else noBLSUnemploymentChartData"
                class="flex-auto w-full h-full"
                [chart]="blsUnemploymentOptions.chart"
                [colors]="blsUnemploymentOptions.colors"
                [fill]="blsUnemploymentOptions.fill"
                [series]="blsUnemploymentOptions.series"
                [stroke]="blsUnemploymentOptions.stroke"
                [tooltip]="blsUnemploymentOptions.tooltip"
                [xaxis]="blsUnemploymentOptions.xaxis"
              ></apx-chart>
              <ng-template #noBLSUnemploymentChartData>
                <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
                  Insufficient data to display graph
                </p>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="flex flex-col flex-auto bg-card shadow-md rounded overflow-hidden mt-4">
        <div class="flex flex-col p-6 pr-4 pb-4">
          <div class="flex items-center justify-between">
            <div class="flex flex-col">
              <div class="font-bold text-md text-secondary uppercase tracking-wider mr-4">Permits</div>
              <div class="text-sm text-hint font-medium">Building permits pulled monthly by county.</div>
            </div>
          </div>
          <div class="flex flex-col flex-auto">
            <ng-container *ngIf="censusPermitsOptions">
              <apx-chart
                *ngIf="(censusPermitsData | json) != '[]'; else noCensusPermitsData"
                class="flex-auto w-full h-full"
                [chart]="censusPermitsOptions.chart"
                [colors]="censusPermitsOptions.colors"
                [fill]="censusPermitsOptions.fill"
                [series]="censusPermitsOptions.series"
                [stroke]="censusPermitsOptions.stroke"
                [tooltip]="censusPermitsOptions.tooltip"
                [xaxis]="censusPermitsOptions.xaxis"
              ></apx-chart>
              <ng-template #noCensusPermitsData>
                <p class="font-bold text-md text-secondary uppercase tracking-wider text-center p-4">
                  Insufficient data to display graph
                </p>
              </ng-template>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</div>
